import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

type Props = {
	onClose: () => void;
	size?: "small" | "medium" | "large";
};

export const CloseButton = (props: Props) => {
	const { onClose, size = "medium" } = props;
	return (
		<IconButton
			aria-label="close"
			onClick={onClose}
			sx={{
				position: "absolute",
				right: 8,
				top: 8,
			}}
		>
			<CloseIcon fontSize={size} />
		</IconButton>
	);
};
